var sections={md:[
    {
      name:"EVENTS",
      icon:"today",
      componentName:"events"
    },
    {
      name:"SHOP",
      icon:"add_shopping_cart",
      componentName:"shop"
    },
    {
      name:"Food Menu",
      icon:"fastfood",
      componentName:"menu"
    },
    {
      name:"Recipes",
      icon:"fastfood",
      componentName:"recipes"
    },
    {
      name:"Gallery",
      icon:"insert_photo",
      componentName:"gallery"
    },
    {
      name:"Radio",
      icon:"radio",
      componentName:"radio"
    },
    {
      name:"General",
      icon:"web_asset",
      componentName:"general"
    },
  ],
  sv:[
    {
      name:"Folder section",
      icon:"folder",
      componentName:"folder"
    },
    {
      name:"Cart",
      icon:"shopping_cart",
      componentName:"cart"
    },
    {
      name:"Orders",
      icon:"shopping_basket",
      componentName:"orders"
    },
    {
      name:"User profile",
      icon:"person",
      componentName:"profile"
    },
    {
      name:"User list",
      icon:"group",
      componentName:"users"
    },
    {
      name:"Map",
      icon:"location_on",
      componentName:"map"
    },
    {
      name:"Notifications",
      icon:"notification_important",
      componentName:"notifications"
    },
    {
      name:"Scanner",
      icon:"filter_center_focus",
      componentName:"scanner"
    },
    {
      name:"Web View",
      icon:"web",
      componentName:"webview"
    },
    {
      name:"Links list",
      icon:"link",
      componentName:"social"
    },{
      name:"Chat list",
      icon:"chat",
      componentName:"chats"
    },{
      name:"Find contact",
      icon:"perm_contact_calendar",
      componentName:"Add Contact"
    },
]}

export default sections;


// WEBPACK FOOTER //
// ./src/config/builder/sections_config.js